import React, { useState, useEffect } from 'react';
import { axios } from '../../context/AuthContext';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const TIPLER = [
  { value:'kardes',         label:'Kardeş İndirimi',    icon:'👨‍👩‍👧‍👦', color:'#3B82F6' },
  { value:'erken_kayit',    label:'Erken Kayıt',         icon:'⏰',  color:'#10B981' },
  { value:'basari_bursu',   label:'Başarı Bursu',        icon:'🏆',  color:'#F59E0B' },
  { value:'personel_cocugu',label:'Personel Çocuğu',     icon:'👔',  color:'#8B5CF6' },
  { value:'sehit_gazi',     label:'Şehit/Gazi Yakını',   icon:'⭐',  color:'#EF4444' },
  { value:'kampanya',       label:'Kampanya',             icon:'🎯',  color:'#F97316' },
  { value:'diger',          label:'Diğer',                icon:'📌',  color:'#6B7280' },
];

function SablonModal({ sablon, onSave, onClose }) {
  const [form, setForm] = useState(sablon || {
    ad:'', tip:'diger', yuzde:'0', sabit_tutar:'0', aciklama:'', onay_gerekli:false, aktif:true,
  });
  const [saving, setSaving] = useState(false);
  const handleSubmit = async () => {
    if (!form.ad) { toast.error('Şablon adı zorunlu'); return; }
    setSaving(true);
    try { await onSave(form); } finally { setSaving(false); }
  };
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{maxWidth:480}} onClick={e=>e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">{sablon?'✏️ Şablon Düzenle':'+ Yeni İndirim Şablonu'}</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:12}}>
          <div className="form-group"><label className="form-label">Şablon Adı *</label>
            <input className="form-input" value={form.ad} onChange={e=>setForm(f=>({...f,ad:e.target.value}))} placeholder="Kardeş İndirimi %10" /></div>
          <div className="form-group"><label className="form-label">Tip</label>
            <select className="form-input" value={form.tip} onChange={e=>setForm(f=>({...f,tip:e.target.value}))}>
              {TIPLER.map(t=><option key={t.value} value={t.value}>{t.icon} {t.label}</option>)}
            </select>
          </div>
          <div className="muh-grid-2">
            <div className="form-group"><label className="form-label">İndirim % (0 = yok)</label>
              <input className="form-input" type="number" step="0.5" value={form.yuzde} onChange={e=>setForm(f=>({...f,yuzde:e.target.value}))} /></div>
            <div className="form-group"><label className="form-label">Sabit Tutar ₺ (0 = yok)</label>
              <input className="form-input" type="number" value={form.sabit_tutar} onChange={e=>setForm(f=>({...f,sabit_tutar:e.target.value}))} /></div>
          </div>
          <div className="form-group"><label className="form-label">Açıklama</label>
            <textarea className="form-input" rows={2} value={form.aciklama} onChange={e=>setForm(f=>({...f,aciklama:e.target.value}))} /></div>
          <div style={{display:'flex',gap:20}}>
            <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',userSelect:'none'}}>
              <input type="checkbox" checked={!!form.onay_gerekli} onChange={e=>setForm(f=>({...f,onay_gerekli:e.target.checked}))} />
              <span style={{fontSize:'0.875rem'}}>Yönetici Onayı Gerekli</span>
            </label>
            {sablon && (
              <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',userSelect:'none'}}>
                <input type="checkbox" checked={!!form.aktif} onChange={e=>setForm(f=>({...f,aktif:e.target.checked}))} />
                <span style={{fontSize:'0.875rem'}}>Aktif</span>
              </label>
            )}
          </div>
        </div>
        <div style={{display:'flex',justifyContent:'flex-end',gap:10,marginTop:16}}>
          <button className="btn btn-secondary" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
            {saving?<div className="spinner" style={{width:16,height:16}}/>:'💾 Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function IndirimSablonlariPage() {
  const { user } = useAuth();
  const [sablonlar, setSablonlar] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [modal, setModal]         = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const r = await axios.get('/muhasebe/indirim-sablonlari');
      if (r.data.success) setSablonlar(r.data.data);
    } catch {} finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const handleSave = async (form) => {
    try {
      if (form.id) await axios.put(`/muhasebe/indirim-sablonlari/${form.id}`, form);
      else         await axios.post('/muhasebe/indirim-sablonlari', form);
      toast.success(form.id?'Güncellendi':'Şablon eklendi');
      setModal(null); load();
    } catch (e) { toast.error(e.response?.data?.message||'Hata'); }
  };

  const tipMap = TIPLER.reduce((a,t)=>({...a,[t.value]:t}),{});

  return (
    <div style={{display:'flex',flexDirection:'column',gap:20}}>
      <div className="section-header animate-fadeInUp">
        <div>
          <h2 style={{fontFamily:'var(--font-ui)',fontWeight:900}}>🏷️ İndirim Şablonları</h2>
          <div className="section-subtitle">Tanımlı indirimler — sözleşmede tek tıkla uygulanır</div>
        </div>
        {['kurucu','muhasebe'].includes(user?.rol) && <button className="btn btn-primary" onClick={()=>setModal('yeni')}>+ Şablon Ekle</button>}
      </div>

      <div style={{background:'rgba(59,130,246,0.06)',border:'1px solid rgba(59,130,246,0.2)',borderRadius:12,padding:'12px 16px',fontSize:'0.85rem',color:'var(--text-secondary)'}}>
        ℹ️ <b>Nasıl çalışır?</b> Sözleşme oluştururken bu şablonlardan birini seçince indirim oranı otomatik uygulanır. 
        "Yönetici Onayı Gerekli" işaretli şablonlar kullanılabilir ama yönetici kaydı onaylayana kadar bekler.
        {!['kurucu','muhasebe'].includes(user?.rol) && ' Şablon ekleme/düzenleme yetkisi Kurucu ve Muhasebe rolüne aittir.'}
      </div>

      {loading ? <div className="page-loader" style={{minHeight:200}}><div className="spinner"/></div>
      : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:14}}>
          {sablonlar.map((s,i)=>{
            const tip = tipMap[s.tip]||tipMap.diger;
            return (
              <div key={i} className="card animate-fadeInUp" style={{borderLeft:`4px solid ${tip.color}`}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
                  <div style={{display:'flex',gap:10,alignItems:'center'}}>
                    <span style={{fontSize:'1.5rem'}}>{tip.icon}</span>
                    <div>
                      <div style={{fontFamily:'var(--font-ui)',fontWeight:800,fontSize:'0.95rem'}}>{s.ad}</div>
                      <div style={{fontSize:'0.72rem',color:'var(--text-muted)'}}>{tip.label}</div>
                    </div>
                  </div>
                  <div style={{display:'flex',gap:6,alignItems:'center'}}>
                    {!s.aktif && <span style={{fontSize:'0.72rem',color:'#94A3B8',background:'var(--bg-elevated)',padding:'2px 8px',borderRadius:99}}>Pasif</span>}
                    {s.onay_gerekli && <span title="Yönetici onayı gerekli" style={{fontSize:'0.9rem'}}>🔐</span>}
                    {['kurucu','muhasebe'].includes(user?.rol) && <button className="btn btn-ghost btn-sm" onClick={()=>setModal(s)}>✏️</button>}
                  </div>
                </div>
                <div style={{display:'flex',gap:12}}>
                  {parseFloat(s.yuzde)>0 && (
                    <div style={{padding:'8px 16px',background:`${tip.color}15`,borderRadius:10,textAlign:'center'}}>
                      <div style={{fontFamily:'var(--font-ui)',fontWeight:900,fontSize:'1.4rem',color:tip.color}}>%{s.yuzde}</div>
                      <div style={{fontSize:'0.68rem',color:'var(--text-muted)'}}>indirim</div>
                    </div>
                  )}
                  {parseFloat(s.sabit_tutar)>0 && (
                    <div style={{padding:'8px 16px',background:`${tip.color}15`,borderRadius:10,textAlign:'center'}}>
                      <div style={{fontFamily:'var(--font-ui)',fontWeight:900,fontSize:'1.2rem',color:tip.color}}>
                        {new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',minimumFractionDigits:0}).format(s.sabit_tutar)}
                      </div>
                      <div style={{fontSize:'0.68rem',color:'var(--text-muted)'}}>sabit</div>
                    </div>
                  )}
                </div>
                {s.aciklama && <div style={{marginTop:10,fontSize:'0.78rem',color:'var(--text-muted)'}}>{s.aciklama}</div>}
              </div>
            );
          })}
        </div>
      )}

      {modal && <SablonModal sablon={modal==='yeni'?null:modal} onSave={handleSave} onClose={()=>setModal(null)} />}
    </div>
  );
}
